<div class="full-height layout-column overflow-x-auto-only">

  <div class="flex layout-column bringoz-table scrollable">
    <div #header class="tr text-uppercase layout-row layout-align-start-center fade-element-in-only">

      <div class="th medium text-ellipsis layout-row layout-align-start-center flex-20">
        {{'Agent' | translate}}
      </div>

      <div class="th xsmall text-ellipsis flex-10">
        {{'Start Time' | translate}}
      </div>

      <div class="th xsmall text-ellipsis flex-10">
        {{'End Time' | translate}}
      </div>

      <div class="th xsmall text-ellipsis flex-10">
        {{'Missed Tasks' | translate}}
      </div>

      <div class="th xsmall text-ellipsis flex-10">
        {{'Hours' | translate}}
      </div>

      <div class="th large text-ellipsis flex">
        {{'Sequence' | translate}}
      </div>

      <div class="th xsmall text-ellipsis flex-10">
        {{'Score' | translate}}
      </div>

      <div class="th xsmall text-ellipsis flex-10"></div>
    </div>

    <div class="full-height flex rows-container layout-column">

      <cdk-virtual-scroll-viewport itemSize="69" class="flex viewport" (scroll)="getNextBatch()">
        <div *cdkVirtualFor="let agentRouteScore of agentsRouteScore"
             [style.height.px]="69">
          <app-dashboard-agents-route-score-table-row class="item"
                                                      [agentRouteScore]="agentRouteScore"
                                                      (viewTasksEvent)="onViewAgentTasks($event.agent, $event.tasks, $event.plannedTasksOrder, $event.actualTasksOrder)"
                                                      (viewAgentRoutesPerformanceEvent)="onViewAgentRoutePerformance($event.agentRef)">

          </app-dashboard-agents-route-score-table-row>
        </div>
      </cdk-virtual-scroll-viewport>

    </div>
  </div>

</div>
